module.exports = __webpack_public_path__ + "static/img/blog-details-with-rightsidebar.df85137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blog-details-with-rightsidebar.jpg
// module id = iFDl
// module chunks = 0